import { CollaborationResult } from '@/infrastructure/gateways/classroom/models/collaboration-result';

const collaborationName = 'RecordCourseProgressCollaboration';

export const CourseNotFoundIdentifier = 'CourseNotFound';
export class CourseNotFound extends CollaborationResult {
  constructor() {
    super(collaborationName, CourseNotFoundIdentifier, 'Course not found to guid sent');
  }
}

export const LessonsNotFoundIdentifier = 'LessonsNotFound';
export class LessonsNotFound extends CollaborationResult {
  constructor() {
    super(collaborationName, LessonsNotFoundIdentifier, 'Lessons progress not found to guid sent');
  }
}

export const CourseProgressCreatedIdentifier = 'CourseProgressCreated';
export class CourseProgressCreated extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      CourseProgressCreatedIdentifier,
      'Course progress created successfully',
    );
  }
}

export const CourseProgressNotCreatedIdentifier = 'CourseProgressNotCreated';
export class CourseProgressNotCreated extends CollaborationResult {
  constructor() {
    super(collaborationName, CourseProgressNotCreatedIdentifier, 'Course progress not created');
  }
}

export const CourseProgressRecordedIdentifier = 'CourseProgressRecorded';
export class CourseProgressRecorded extends CollaborationResult {
  constructor(data) {
    super(
      collaborationName,
      CourseProgressRecordedIdentifier,
      'Course progress updated successfully',
      data,
    );
  }
}

export const CourseProgressRecordedBecauseWasCompleteIdentifier =
  'CourseProgressRecordedBecauseWasComplete';
export class CourseProgressRecordedBecauseWasComplete extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      CourseProgressRecordedBecauseWasCompleteIdentifier,
      'Course progress completed successfully',
    );
  }
}

export const CourseProgressNotRecordedBecauseWasCompleteIdentifier =
  'CourseProgressNotRecordedBecauseWasComplete';
export class CourseProgressNotRecordedBecauseWasComplete extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      CourseProgressNotRecordedBecauseWasCompleteIdentifier,
      'Course progress not registered becaus was completed',
    );
  }
}

export const CourseProgressNotRecordedBecauseStudentNotFoundIdentifier =
  'CourseProgressNotRecordedBecauseStudentNotFound';
export class CourseProgressNotRecordedBecauseStudentNotFound extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      CourseProgressNotRecordedBecauseStudentNotFoundIdentifier,
      'Course progress not recorded because the student was not found',
    );
  }
}

export const RecordCourseProgressUnexpectedErrorIdentifier = 'RecordCourseProgressUnexpectedError';
export class RecordCourseProgressUnexpectedError extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      RecordCourseProgressUnexpectedErrorIdentifier,
      'Unexpected error occurred on the service',
    );
  }
}

export const UnexpectedExceptionIdentifier = 'UnexpectedException';
export class UnexpectedException extends CollaborationResult {
  constructor() {
    super(
      collaborationName,
      UnexpectedExceptionIdentifier,
      'Unexpected error occurred on the service',
    );
  }
}
